// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--Us90Q","text":"_93444fe79c--text--odfsh","close":"_93444fe79c--close--bl_Qb","hands-ver1":"_93444fe79c--hands-ver1--sQGOt"};